import FranchiseHero from './components/FranchiseHero';
import { img, readdy } from '@/utils/images';
import OrgStructure from './components/OrgStructure';
import AdvantagesSection from './components/AdvantagesSection';
import TargetGroups from './components/TargetGroups';
import SupportSystem from './components/SupportSystem';
import ApplyProcess from './components/ApplyProcess';

function FranchiseCtaBanner() {
  return (
    <section className="relative overflow-hidden py-0">
      <div className="relative h-56 md:h-72">
        <img
          src={readdy('franchise-banner-001')}
          alt="颜轻至门店环境"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-deep/80 via-brand-deep/60 to-transparent" />
        <div className="absolute inset-0 flex items-center">
          <div className="px-6 md:px-10 max-w-2xl">
            <h2 className="text-2xl md:text-3xl font-bold text-white leading-tight mb-3">
              现在咨询，优先获取区域资格
            </h2>
            <p className="text-white/60 text-sm mb-5">
              区域保护名额有限，先申请先获得保护。部分城市热门区域已有待审申请。
            </p>
            <a
              href="#apply-process"
              className="inline-flex items-center gap-2 px-8 py-3 bg-white text-brand-deep text-sm font-medium rounded-full hover:bg-brand-light transition-colors cursor-pointer whitespace-nowrap"
            >
              了解申请流程
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function FranchisePage() {
  return (
    <main>
      <FranchiseHero />
      <OrgStructure />
      <AdvantagesSection />
      <FranchiseCtaBanner />
      <TargetGroups />
      <SupportSystem />
      <ApplyProcess />
    </main>
  );
}